import React from "react"
import { CURRENCY } from "../helpers/constant"

export function calculatePayAsYouGoAddonAmount(product, credits) {
  let slabs = product.dropdown_options
  let slab = {
    max: 0,
    min: 0,
    unit_price: 0
  }
  let actual_amount = 0

  if (slabs && slabs.length > 0) {
    slab = slabs.find(function (s) {
      if (s.data.min <= credits && (s.data.max ? s.data.max : Infinity) >= credits)
        return s
      return false
    })
    actual_amount = credits * slab.data.unit_price
  }

  return {
    slab: slab,
    credits: credits,
    amount: actual_amount
  }
}

export const calculateAddonAmount = (product, quantity) => {
  const totalCount = product.limits.count
  const price = product.price.total_price
  const totalQuantity = quantity / totalCount
  return formatNumberToXDecimalPlace(price * totalQuantity, 2)
}

export const formatNumberToXDecimalPlace = (number, x) => {
  const DOT = '.'
  number = Math.round(number * 1e10) / 1e10
  number = number.toString()
  let indexOfDot = number.indexOf(DOT)

  if (indexOfDot !== -1) {
    number = number.slice(0, indexOfDot + x + 1)
  }

  return +number
}

export const getPriceString = ({ price, currency, minimumFractionDigits = null, maximumFractionDigits = null }) => {
  let localeStringOpts = {}

  if (typeof maximumFractionDigits === 'number')
    localeStringOpts.maximumFractionDigits = maximumFractionDigits

  if (typeof minimumFractionDigits === 'number')
    localeStringOpts.minimumFractionDigits = minimumFractionDigits

  return (
    <span>
      {`${CURRENCY[currency]?.symbol}${Number(price).toLocaleString(CURRENCY.USD.locale, localeStringOpts)}`}
    </span>
  )
}